<template>
  <v-card class="invpreview" :class='pdf' :flat='pdf ==="pdf"'>
    <v-card-text>
<v-layout align-center justify-center row fill-height >
      <v-flex xs9 text-xs-left >
        <!-- <img :src="imageUrl" :width="quote.logoWidth" :class="quote.logoAlign"> -->
        <img v-if="quote.useLogo" :src="imageUrl" :width="quote.logoWidth" class="left invoicelogo">
      <span
      v-if="!quote.useLogo && quote.useLogo !== ''"
      class="bold"
      :style="{
        fontSize: `${quote.logoNameSize}px`,
        whiteSpace: 'pre',
        lineHeight: '1.2em'
      }"
      >{{quote.logoName}}</span>
      </v-flex>
      <v-flex xs3 text-xs-left>
        <h1 class="headline bold text-xs-right">Quote</h1>
        <transition name="bounce">
      <!-- <div class="paidstamp" v-show='invoice.status === "Paid"'><img src="../../assets/paidstamp.png" alt="paid" ></div> -->
      <div class="paidstamp" v-show='quote.status === "Accepted"'><div>Accepted</div></div>
    </transition>
      </v-flex>
    </v-layout>
      <v-layout row  :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'mt-5'">
      <v-flex  xs8 >
        <h3 class="head-bar">Client details</h3>
        <div class="py-2 px-2">
          <span v-if='quote.contact' class="d-block">{{quote.contact}}</span>
          <span v-if='quote.clientName' class="d-block">{{quote.clientName}}</span>
          <span v-if='quote.clientAddress' class="d-block" v-html="quote.clientAddress" style="white-space: pre;"></span>
          <span v-if='quote.clientAddress2' class="d-block">{{quote.clientAddress2}}</span>
          <span v-if='quote.clientTown' class="d-block">{{quote.clientTown}}</span>
          <span v-if='quote.clientCounty' class="d-block">{{quote.clientCounty}}</span>
          <span v-if='quote.clientCountry' class="d-block">{{quote.clientCountry}}</span>
          <span v-if='quote.postCode' class="d-block">{{quote.postCode}}</span>
        </div>
      </v-flex>
      <v-flex xs4 offset-xs-1  text-xs-left>
        <h3 class="head-bar">Quote details</h3>
        <div class="py-2 px-2">
          <div>
          <span class="bold pr-1 d-block">Quote No</span>
          <span>{{ quoteRef }}</span>
          </div>
          <div>
            <span class="bold pr-1 d-block mt-2">Quote Date</span>
            <span>{{ quotedDateFormatted }}</span>
          </div>
          <div>
            <span class="bold pr-1 d-block mt-2">Valid to</span>
            <span>{{ validtoDateFormatted }}</span>
          </div>
        </div>
      </v-flex>
      </v-layout>
      <div class="mt-4">
        <div v-if="quote.note" v-html="`<strong>Quote note:</strong><br>${quote.note.replace(/(?:\r\n|\r|\n)/g, '<br>')}`"></div>
        <div v-if="quote.taxIncluded && quote.chargeTax">
          <p class="body-tiny pl-2">Prices inclusive of {{quote.taxLabel || "VAT"}}</p>
        </div>
        <table class="invoice-lines">
          <thead>
            <tr>
              <th><h3>Items</h3></th>
              <th v-if="quote.chargeTax"><h3>Amount</h3></th>
              <th v-if="quote.chargeTax"><h3>{{quote.taxLabel || "VAT"}}</h3></th>
              <th><h3>Total</h3></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item) in quote.lineItems"  :key="item.id">
              <td>
                {{item.description}}
              </td>
              <td v-if="quote.chargeTax">
                {{item.netAmount | toCurrency(quote.lang, quote.currCode)}}
              </td>
              <td v-if="quote.chargeTax">
                {{item.taxPortion | toCurrency(quote.lang, quote.currCode)}} <span class="body-tiny">({{item.taxRate}}&percnt;)</span>
              </td>
              <td>
                {{ item.lineTotal | toCurrency(quote.lang, quote.currCode) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-divider class="divider mb-2"></v-divider>
      <v-layout v-if="quote.chargeTax" class="px-2">
        <v-flex xs9 text-xs-left >
          TOTAL (excl {{quote.taxLabel || "VAT"}})
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ quote.totalNetAmount | toCurrency(quote.lang, quote.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-if="quote.chargeTax" class="px-2">
        <v-flex xs9 text-xs-left >
          TOTAL {{quote.taxLabel || "VAT"}}
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ quote.totalTaxPortion | toCurrency(quote.lang, quote.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-if="quote.chargeTax" class="offwhite px-2 xbold">
        <v-flex xs9 text-xs-left >
          TOTAL (incl {{quote.taxLabel || "VAT"}})
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ quote.amount | toCurrency(quote.lang, quote.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout v-else class="offwhite px-2 xbold">
        <v-flex xs9 text-xs-left >
          TOTAL
        </v-flex>
        <v-flex xs3 text-xs-right>
          {{ quote.amount | toCurrency(quote.lang, quote.currCode) }}
        </v-flex>
      </v-layout>
      <v-layout row mt-5 class="invfooter">
        <v-flex xs8>
          <h3 class="head-bar">Payment &amp; Terms</h3>
          <div class="py-2 pl-2 pr-5">
            <span v-html="quote.paymentTerms.replace(/(?:\r\n|\r|\n)/g, '<br>')" class="shortp"></span>
          </div>
        </v-flex>
        <v-flex xs4 text-xs-left>
          <h3 class="head-bar">Contact details</h3>
          <div class="py-2 px-2">
            {{ quote.groupTitle}}<br>
            <address-display
              :groupAddress="quote.groupAddress"
              :groupAddress1="quote.groupAddress1"
              :groupAddress2="quote.groupAddress2"
              :groupCityRegion="quote.groupCityRegion"
              :groupCountyState="quote.groupCountyState"
              :groupPostcode="quote.groupPostcode"
              :groupCountry="quote.groupCountry"
            ></address-display>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>

import AddressDisplay from '@/components/Shared/AddressDisplay'

export default {
  name: 'QuotePreview',
  components: {
    AddressDisplay
  },
  props: [
    'quote',
    'imageUrl',
    'quotedDateFormatted',
    'validtoDateFormatted',
    'pdf',
    'displayedQuoteNumber'
  ],
  computed: {
    quoteRef () {
      return this.displayedQuoteNumber ? this.displayedQuoteNumber : this.quote.quote_ref
    }
  }
}
</script>

<style lang="scss">
.invoicelogo{
  max-width:100%;
}
.xsOnly .invoicelogo{
  max-width:50%;
}
.headline{
    font-size: calc(20px + 1vw) !important;
}

.invpreview{
  padding:30px;
  // leading grows along with font,
  font-size: calc(4px + .5vw);
  // with an additional 0.1em + 0.5px per 100px of the viewport
  line-height: calc(1.1em + 0.4vw);
  &.pdf{
    font-size:80%;
    line-height: 1.3rem;
    .head-bar{
      font-size:1.1rem;
    }
    .headline{
      font-size:2.8rem !important;
    }
  }
}
.xsOnly .invpreview{
  padding:0;
  font-size:55%;
}

.row{
    padding:5px 0;
}
.divider{
  background: var(--light-text);
}
.nowrap{
  white-space: nowrap;
}
.offwhite{
  background:var(--invoice-heading-bg);
}
.xsOnly .paidstamp div{
  font-size:1.5rem;

}
.paidstamp{
  // width:150px;
  text-align: right;

  img{
    max-width:100%;
  }
  div{
    color:var(--red);
    font-size:2rem;
    font-weight:700;
  }
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(2);
    opacity:0;
  }
  100% {
    transform: scale(1);
    opacity:1;
  }
}
  span.shortp > p {
    margin: 0 !important;
    padding: 0;
    }
  .invfooter{
    p{
      padding-bottom:0;
      margin-bottom:0;
    }
  }
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit !important;
  }

</style>
